import Keyboard from "./components/Keyboard";

export default Keyboard;
